import { FunctionComponent, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import CloseIcon from 'components/SVG/DeleteXCircle'
import Spacer from 'components/Spacer'

interface IHeightProps {
  height: number
  gutterPadding?: boolean
}
const OverflowContainer = styled.div<IHeightProps>`
  height: ${props => props.height}px;
  overflow: hidden;
  transition: height 250ms;
  @media (max-width: ${props => props.theme.metrics.phone}px) {
    ${props =>
    props.gutterPadding && `padding: 10px ${props.theme.metrics.listingFlowGutterPhone}px 0;`}
  }
`

const Banner = styled.div`
  background: ${props => props.theme.colors.yellow};

  padding: 13px 20px; /* 2px vertical font correction */
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledText = styled.div`
  padding-top: 5px; /* font correction */
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${props => props.theme.colors.black};
`

const ClickContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`
interface IProps {
  customHeight?: number
  customText?: string
  gutterPadding?: boolean
}
const PreviewBanner: FunctionComponent<IProps> = ({ customHeight, customText, gutterPadding }) => {
  const theme = useContext(ThemeContext)

  const [open, setOpen] = useState(true)
  const closeBanner = () => setOpen(false)

  const defaultText = 'This is a preview of your draft listing.'
  const maxHeight = customHeight || 67

  return (
    <OverflowContainer
      height={open ? maxHeight : 0}
      gutterPadding={gutterPadding}
    >
      <Banner>
        <StyledText>{customText || defaultText}</StyledText>
        <ClickContainer onClick={closeBanner}>
          <CloseIcon
            width={20}
            height={20}
            fill={theme.colors.black}
          />
        </ClickContainer>
      </Banner>
      <Spacer size={15} />
    </OverflowContainer>
  )
}

export default PreviewBanner
